export const config = { ...window.ENV }
export const customize = { ...window.CUSTOMIZE }

// function to get strings from customization a bit shorter
export const _ = (str) => customize.strings[str]
